// frontend/src/components/content/DiscussionForum.js (فایل جدید)

import React, { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../../modules/api';
import { FaComments, FaSpinner } from 'react-icons/fa';
import DiscussionPostItem from './DiscussionPostItem';
import PostForm from './PostForm';

const DiscussionForum = ({ lessonId }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // از useCallback استفاده می‌کنیم تا این تابع در چرخه‌های رندر مکرر ساخته نشود
    const fetchPosts = useCallback(async () => {
        setLoading(true); // هنگام رفرش هم لودینگ نشان بده
        try {
            const response = await axiosInstance.get(`/core/lessons/${lessonId}/posts/`);
            setPosts(response.data);
            setError(null);
        } catch (err) {
            console.error("Error fetching discussion posts:", err);
            setError("خطا در بارگذاری پیام‌ها.");
        } finally {
            setLoading(false);
        }
    }, [lessonId]); // این تابع فقط زمانی که lessonId عوض شود، دوباره ساخته می‌شود

    // اجرای اولیه برای دریافت پست‌ها
    useEffect(() => {
        fetchPosts();
    }, [fetchPosts]); // [fetchPosts] شامل lessonId است

    const renderPosts = () => {
        if (loading) {
            return <div className="text-center p-5"><FaSpinner className="spinner" /></div>;
        }
        if (error) {
            return <div className="alert alert-danger">{error}</div>;
        }
        if (posts.length === 0) {
            return <p className="text-center text-gray-400 p-4">هنوز سؤالی پرسیده نشده است. اولین نفر باشید!</p>;
        }
        return (
            <div className="posts-list">
                {posts.map(post => (
                    <DiscussionPostItem
                        key={post.id}
                        post={post}
                        lessonId={lessonId}
                        onReplySuccess={fetchPosts} // تابع رفرش را پاس می‌دهیم
                    />
                ))}
            </div>
        );
    };

    return (
        <div className="discussion-container">
            <h3 className="discussion-header">
                <FaComments /> تالار گفتگوی درس
            </h3>
            
            {/* فرم ارسال سوال جدید */}
            <div className="new-question-form">
                <h4>پرسش جدید</h4>
                <PostForm
                    lessonId={lessonId}
                    buttonText="ثبت سوال"
                    onSuccess={fetchPosts} // پس از ارسال سوال، لیست را رفرش کن
                />
            </div>

            {/* لیست سوالات و پاسخ‌ها */}
            {renderPosts()}
        </div>
    );
};

export default DiscussionForum;